import { render } from "./Legals.vue?vue&type=template&id=4bb9a04f"
import script from "./Legals.vue?vue&type=script&lang=js"
export * from "./Legals.vue?vue&type=script&lang=js"
script.render = render

export default script